<template>
  <div class="picker-selector">
    <div class="selector-input" @click="showPicker = true">
      <van-field :value="displayText" :label="textFiled" readonly :placeholder="placeholder" />
      <img src="@/assets/images/down.png" alt="下拉" />
    </div>

    <van-popup
      v-model="showPicker"
      position="bottom"
      round
      :style="{ height: '70%' }"
    >
      <div class="popup-frame">
        <van-search
          v-model="searchQuery"
          :placeholder="searchPlaceholder"
          @input="handleSearch"
        />

        <!-- <van-radio-group
          class="option-list"
          v-model="selectedValue"
          direction="horizontal"
          @change="handleSelect"
        >
          <van-radio
            v-for="item in filteredOptions"
            :key="item.value"
            :name="item.value"
            :class="{ active: selectedValue === item.value }"
          >
            {{ item.label }}
          </van-radio>
        </van-radio-group> -->

        <van-checkbox-group @change="handleSelect" v-model="selectedValue" class="option-list" direction="horizontal">
          <van-checkbox v-for="(item,idx) in filteredOptions" :class="{ active: selectedValue[idx] === item.value }" :key="item.value" :name="item.value" >{{ item.label }}</van-checkbox>
        </van-checkbox-group>

      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "PickerSelector",
  props: {
    // 选项列表
    options: {
      type: Array,
      default: () => [],
    },
    // 当前选中的值
    value: {
      type: [String, Number],
      default: "",
    },
    // 占位文本
    placeholder: {
      type: String,
      default: "请选择",
    },
    // 选项列表
    textFiled: {
      type: String,
      default: '',
    },
    // 搜索框占位文本
    searchPlaceholder: {
      type: String,
      default: "请输入",
    },
    // 是否在顶部添加"全部"选项
    showAllOption: {
      type: Boolean,
      default: true,
    },
    // 新增搜索匹配方式属性
    searchMode: {
      type: String,
      default: "default", // 'default'或'account'
      validator: (value) => ["default", "account"].includes(value),
    },
  },
  data() {
    return {
      showPicker: false,
      searchQuery: "",
      selectedValue: [],
      allOptions: [],
      filteredOptions: [],
    };
  },
  computed: {
    displayText() {
      if (!this.selectedValue && this.showAllOption) {
        return this.placeholder;
      }
      const selectedOption = this.allOptions.find(
        (item) => item.value === this.selectedValue
      );
      return selectedOption ? selectedOption.label : this.placeholder;
    },
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
    options: {
      immediate: true,
      handler(newVal) {
        this.allOptions = [...newVal];
        if (this.showAllOption && newVal.length > 0) {
          this.allOptions.unshift({
            value: "",
            label: this.placeholder,
          });
        }
        this.filteredOptions = [...this.allOptions];
      },
    },
  },
  methods: {
    handleSearch() {
      if (!this.searchQuery) {
        this.filteredOptions = [...this.allOptions];
        return;
      }
      if (this.searchMode === "account") {
        // 账户特殊搜索逻辑 - 按ID或名称搜索
        this.filteredOptions = this.allOptions.filter((item) => {
          return item.label.toString().includes(this.searchQuery.toLowerCase());
        });
      } else {
        this.filteredOptions = this.allOptions.filter((item) =>
          item.label.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
    },
    handleSelect(value) {
      console.log('handleSelect called with value: ', value);
      console.log('this.selectedValue',this.selectedValue);
      console.log('this.filteredOptions',this.filteredOptions);
      
      // this.selectedValue = value;
      // this.searchQuery = "";
      // this.filteredOptions = [...this.allOptions];

      // 触发父组件事件
      // this.$emit("input", value);
      // this.$emit("change", value);

      // // 返回选中的完整对象
      // const selectedItem = this.allOptions.find((item) => item.value === value);
      // this.$emit("select", selectedItem);
    },
  },
};
</script>

<style scoped lang="scss">
.picker-selector {
  .selector-input {
    width: 100%;
    height: 22px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #ded9d9;
    font-family: Inter;
    font-weight: 400;
    color: #000000;
    align-items: center;
    display: flex;

    .van-cell {
      padding: 0;
      padding-left: 10px;
      width: 80%;
      height: 100%;
      font-size: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    img {
      flex: 1;
      width: 12px;
      height: 13px;
      object-fit: contain;
    }
  }

  .popup-frame {
    padding: 19px 16px;
    box-sizing: border-box;

    ::v-deep(.van-search) {
      padding: 0;
    }

    ::v-deep(.van-search),
    ::v-deep(.van-search__content) {
      border-radius: 16px !important;
      background: #f3f3f3;
    }

    .option-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -5px;
      margin-top: 11px;

      .van-checkbox {
        flex: 0 0 calc(33.333% - 10px);
        margin: 0 5px 8px 5px;
        font-family: Inter;
        font-weight: 400;
        font-size: 12px;
        background: #eaeaea;
        border-radius: 4px;
        padding: 7px 0;
        text-align: center;
        box-sizing: border-box;

        ::v-deep(.van-checkbox__label) {
          color: #000000 !important;
        }
      }

      ::v-deep(.van-checkbox__icon .van-icon) {
        display: none !important;
      }

      ::v-deep(.van-checkbox__label) {
        margin: auto;
      }

      .active {
        background: #2575f2;

        ::v-deep(.van-checkbox__label) {
          color: #ffffff !important;
        }
      }
    }
  }
}
</style>
